import $ from "jquery";

const input = $('input, textarea');

$(function () {
    input.on('focusin', function () {
        $(this).parents('.form-group').addClass('active');
    });

    input.on('focusout', function () {
        if (!this.value) {
            $(this).parents('.form-group').removeClass('active');
        }
    });

    function checkParams(formName) {
        $('#' + formName + ' .required').each(function () {
            let inputValue = $(this).val();

            if (inputValue.length !== 0) {
                $(this).parent().addClass('active blue');
                $('#' + formName + '-submit').removeAttr('disabled');
            } else {
                $(this).parent().removeClass('active blue');
                $('#' + formName + '-submit').attr('disabled', 'disabled');
            }
        })
    }

    checkParams('sign-in');
    checkParams('registration');
    checkParams('reg-question');
    checkParams('restore');
    checkParams('restore-password');
    checkParams('new-topic');

    input.on('keyup', function () {
        checkParams('sign-in');
        checkParams('registration');
        checkParams('reg-question');
        checkParams('restore');
        checkParams('restore-password');
        checkParams('new-topic');
    });

    input.keypress(function (e) {
        const code = (e.keyCode ? e.keyCode : e.which);

        if (code === 13) {
            $(this).parents('form').find('button[type="button"]:enabled').click();

            return false;
        }
    });
});


